$(document).ready( function() {
    $('.lucci-ovipro .ovipro-filters .ovipro-filter-form').submit( function(event) {
        event.preventDefault();
        var formData = getFormDataAsUrlParams($(this))
        var urlWithParams = window.location.origin + window.location.pathname + '?' + formData;
        window.location.href = urlWithParams;
    })

    $('.search-realties-form .ovipro-filters .ovipro-filter-form').submit( function(event) {
        event.preventDefault();
        var formData = getFormDataAsUrlParams($(this))
        var actionUrl = $(this).attr('action');
        var urlWithParams = actionUrl + '?' + formData;
        window.location.href = urlWithParams;
    })

    $('.ovipro-filters .reset').click(function() {
        resetFormData($(this).closest('form'))
    })

    $('.ovipro-filters.searched .edit-search').click( function() {
        $('.ovipro-filters.not-searched').show()
        $('html, body').animate({
            scrollTop: $('html, body').offset().top
        }, 1000);
        $(this).closest('.ovipro-filters').hide()
    })

    $('.ovipro-filters.searched #order').change( function() {
        var currentUrl = window.location.href;
        var orderValue = $(this).val();
        if (currentUrl.indexOf('?') > -1) {
            var urlParameters = currentUrl.split('?')[1].split('&');
            var updatedUrl = currentUrl.split('?')[0] + '?';
        
            var orderParamExists = false;
        
            for (var i = 0; i < urlParameters.length; i++) {
                var param = urlParameters[i].split('=');
                
                if (param[0] === 'order') {
                    param[1] = orderValue;
                    orderParamExists = true;
                }
                
                updatedUrl += param[0] + '=' + param[1];
                
                if (i < urlParameters.length - 1) {
                    updatedUrl += '&';
                }
            }
            
            if (!orderParamExists) {
                updatedUrl += '&order=' + orderValue;
            }
        } else {
            updatedUrl = currentUrl + '?order=' + orderValue;
        }
        
        window.location.href = updatedUrl;
    })

    $('.ovipro-filter-form input, .ovipro-filter-form select').change( function() {

        var form = $(this).closest('form')

        getRealtiesCount(form)
    })
})

function getFormDataAsUrlParams(form) {

    var formData = '';

    form.find(':input:not([type=submit])').each(function() {
        var input = $(this);
        if( input.val() ) {
            if (input.is(':radio')) {
                if (input.is(':checked')) {
                    if (formData !== '') { formData += '&'; }
                    formData += input.attr('name') + '=' + encodeURIComponent(input.val());
                }
            } else {
                if (formData !== '') { formData += '&'; }
                formData += input.attr('name') + '=' + encodeURIComponent(input.val());
            }
        }
    });

    if (formData !== '') { formData = '?' + formData; }
    return formData;
}

function resetFormData(form) {
    form.find(':input:not([type=submit])').each(function() {
        var input = $(this);
        if( input.val() && ! input.is(':radio') ) {
            input.val('')
        }
    });
}

function getRealtiesCount(form) {
    var search_count_elem = form.find('.search-count')

    var type = form.find('.property-types input[name=type]:checked').val()
    var area = form.find('#area').val()
    var rooms = form.find('#rooms').val()
    var realty_type = form.find('#realty-type').val()
    var min_price = form.find('#min-price').val()
    var max_price = form.find('#max-price').val()
    var min_floor_area = form.find('#min-floor-area').val()
    var max_floor_area = form.find('#max-floor-area').val()

    $.ajax({
        type: "POST",
        dataType: "json",
        url: ajaxurl,
        data: {
            'action': 'count_realties_ajax',
            'type': type,
            'area': area,
            'rooms': rooms,
            'realty-type': realty_type,
            'min-price': min_price,
            'max-price': max_price,
            'min-floor-area': min_floor_area,
            'max-floor-area': max_floor_area
        },
        success: function(data){
            if(data.count) {
                search_count_elem.text(data.count)
            } else {
                search_count_elem.text('0')
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            console.log(jqXHR, textStatus, errorThrown);
        }

    });
}